import { titleCaseLabel } from "../../utils/workspacePresentation";

function warningTone(level) {
  if (level === "high" || level === "high_risk") {
    return "border-rose-200 bg-rose-50 text-rose-700";
  }
  return "border-amber-200 bg-amber-50 text-amber-700";
}

export default function RenterWarningsPanel({
  warnings = [],
  strictModeEnabled = false,
  agreementCompletionBlocked = false,
  title = "Important Notices",
  acknowledgementRequired = false,
}) {
  if (!strictModeEnabled && !agreementCompletionBlocked && !warnings.length) {
    return null;
  }

  return (
    <section className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-sm">
      <div className="flex flex-wrap items-center gap-3">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-rose-500">
          {title}
        </p>
        {strictModeEnabled ? (
          <span className="rounded-full border border-rose-200 bg-rose-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.16em] text-rose-700">
            Strict mode enabled
          </span>
        ) : null}
        {agreementCompletionBlocked ? (
          <span className="rounded-full border border-rose-200 bg-rose-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.16em] text-rose-700">
            Completion blocked
          </span>
        ) : null}
        {acknowledgementRequired && warnings.length ? (
          <span className="rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.16em] text-amber-700">
            Acknowledgement required
          </span>
        ) : null}
      </div>
      <p className="mt-3 text-sm leading-6 text-slate-600">
        These notices help explain the arrangement and record what you reviewed. They do not by
        themselves guarantee legal classification compliance.
      </p>
      {agreementCompletionBlocked ? (
        <div className="mt-4 rounded-2xl border border-rose-200 bg-rose-50 px-4 py-4 text-sm text-rose-700">
          This arrangement cannot move forward until the blocking issue is fixed or the required
          acknowledgement is recorded.
        </div>
      ) : null}
      {warnings.length ? (
        <div className="mt-4 grid gap-3">
          {warnings.map((warning, index) => (
            <article
              key={`${warning.warning_type || "warning"}-${index}`}
              className={`rounded-2xl border px-4 py-4 text-sm ${warningTone(warning.level)}`}
            >
              <div className="font-semibold">
                {warning.message || titleCaseLabel(warning.warning_type)}
              </div>
              {warning.warning_type ? (
                <div className="mt-2 text-xs font-semibold uppercase tracking-[0.16em]">
                  Code: {titleCaseLabel(warning.warning_type)}
                </div>
              ) : null}
            </article>
          ))}
        </div>
      ) : null}
    </section>
  );
}
